import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../../../../environments/environment";
let apiurl = environment.smsUrl[window.location.origin]

@Injectable({
    providedIn: 'root',
})
export class GcsBucketService {

    constructor(private http: HttpClient) {

    }
    uploadFile(file: File, urlpath: string): Promise<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('bucketPath', urlpath);
        return this.http.post(`${apiurl}/upload`, formData, {
            reportProgress: true,
            observe: 'events' // to track upload %
        }).toPromise().then(res => res);
    }
    // openGcsFile(key: string) {
    //     window.open(`${apiurl}/gcsdownload?key=${key}`, '_blank');
    // } 
    getPreSignedUrl(key: string): Promise<string> {
        return this.http.get<{ url: string }>(`${apiurl}/getGcsPreSignedUrl?key=${key}`)
            .toPromise()
            .then(result => result.url);
    }
}